import storageSession from 'redux-persist/lib/storage/session';
import { createTransform } from 'redux-persist';
import { get, set, cloneDeep } from 'lodash';

export const PERSIST_PATHS = {
  shared: [
    'companyCode',
    'period',
    'taxYear',
    'countryTaxType',
    'entryType',
    'activity',
    'bookType',
    'connection',
    'reportingCurrencyCode',
  ],
  balanceSheetManagement: [
    'shared.countryTaxType',
    'shared.taxPeriods',
    'aggregation.periodFrom',
    'aggregation.periodTo',
    'aggregation.slGroupType',
    'aggregation.slGroupItem',
    'aggregation.countryTaxType',
  ],
  dashboard: [
    'provisionQualitySingle.resourceType',
    'provisionQualitySingle.businessCode',
  ],
  scenario: [
    'shared.selectedBaseScenario',
    'shared.selectedScenarioToCompare',
  ],
};

const persistedSlices = Object.keys(PERSIST_PATHS);

const copyDefinedLeaf = (source, target, path) => {
  const value = get(source, path);
  if (typeof value !== 'undefined') {
    set(target, path, value);
  }
};

const whitelistLeavesTransform = createTransform(
  (inboundState, key) => {
    const paths = PERSIST_PATHS[key];
    if (!paths) {
      return inboundState;
    }
    const picked = {};
    paths.forEach(path => copyDefinedLeaf(inboundState, picked, path));
    return picked;
  },
  outboundState => outboundState,
  { whitelist: persistedSlices }
);

// Overlays only whitelisted leaves so sibling fields survive rehydration.
const leafPathsReconciler = (inboundState, originalState, reducedState) => {
  const newState = cloneDeep(reducedState);
  if (!inboundState) {
    return newState;
  }

  Object.entries(PERSIST_PATHS).forEach(([slice, paths]) => {
    paths.forEach(path => copyDefinedLeaf(inboundState, newState, `${slice}.${path}`));
  });

  return newState;
};

const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: persistedSlices,
  transforms: [whitelistLeavesTransform],
  stateReconciler: leafPathsReconciler,
};

export default persistConfig;
